var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cleave',{staticClass:"form-control",attrs:{"value":_vm.value,"raw":_vm.raw,"options":_vm.date,"placeholder":"YYYY-MM-DD"},on:{"input":_vm.input,"blur":_vm.blur}})}
var staticRenderFns = []

export { render, staticRenderFns }